export default ({ request }) => ({

  quotationListApi (data = {}) {
    return request({
      url: '/digitalCenter/quotation/list',
      method: 'post',
      data
    })
  }
})
